import type { NavigateFunction } from 'react-router-dom'
import { confirmDialog } from '../dialogs'

// The "buy a subscription" prompt shown when a locked control is used.
// Button and Input had byte-identical copies of this block.
export const showPremiumLockPrompt = (
  navigate: NavigateFunction,
  message?: string,
) => {
  // No severity mark: a locked control is not an error, and the red one this
  // carried made an upsell read as something the user had broken.
  //
  // It no longer dismisses itself either. sweetalert2 was passed
  // `timer: '4000'` — a string, which is why the whole options object needed an
  // `as unknown as SweetAlertOptions` cast to compile, and setTimeout coerced
  // it — so this prompt has always vanished after four seconds. It asks a
  // question, and a question that disappears while it is being read is the one
  // thing a confirm dialog must not do.
  void confirmDialog({
    title: 'Cumpără un abonament',
    text: message,
    confirmText: 'Cumpără abonament',
  }).then(confirmed => {
    if (confirmed) {
      navigate('/abonamente')
    }
  })
}
